<template>
    <div class="customcolumn column" :class="column">
        <div class="list-box">
            <div class="inr-title">{{status.name}}</div>
            <div class="list-container">
                <template v-if="orderData && orderData.salesOrders">
                    <template v-for="(order, index) in orderData.salesOrders.data">
                        <OrderGridItem :item="order" :id="index"></OrderGridItem>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import OrderGridItem from "./OrderGridItem";
export default {
    name: "OrdersByStatus",
    components: {OrderGridItem},
    props: ['status', 'orderData', 'column'],
    methods: {

    }
}
</script>

<style scoped>

</style>
